import React from 'react'

import Flex from 'components/Flex'
import ArrowForward from 'components/icons/ArrowForward'
import {
  CardText,
  CardValue,
  CursorPointer,
  SingleCard,
  TopHeader,
} from 'components/InfoCards/style'
import { useNavigate } from 'react-router'
import { COLORS } from 'theme'
import { SubText } from './style'

const InfoCards = ({
  background = COLORS.BLUE_T_95,
  padding = '15px 25px',
  width = 'auto',
  icon,
  text,
  clickIcon,
  navigation,
  value,
  height,
  state,
  current,
  onClick,
  value1,
  value2,
  text1,
  text2,
  onCardClick,
}) => {
  const navigate = useNavigate()
  const clickedFn = () => {
    navigate(navigation)
  }
  return (
    <SingleCard
      onClick={onClick || (onCardClick && clickedFn)}
      background={current && state == current ? COLORS.BLUE_T_80 : background}
      padding={padding}
      width={width}
      column
      flexStart
      height={height}
      spaceBetween
    >
      {icon}
      <CardText fontSize={14}>{text}</CardText>
      <TopHeader row spaceBetween alignCenter>
        {value || value === 0 ? (
          <Flex flexStart>
            <CardValue>{value}</CardValue>
          </Flex>
        ) : (
          <Flex row flexStart>
            <CardValue>{value1}</CardValue>
            <SubText>{text1}</SubText>
            <CardValue>{value2}</CardValue>
            <SubText>{text2}</SubText>
          </Flex>
        )}
        <Flex flexEnd>
          {clickIcon && (
            <CursorPointer onClick={clickedFn}>
              <ArrowForward />
            </CursorPointer>
          )}
        </Flex>
      </TopHeader>
    </SingleCard>
  )
}

export default InfoCards
